var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["e-circular", "e-circular-history-summary"] },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            title: _vm.title,
            needRightTop: true,
            buttons: [],
            status: _vm.currentHistory.status,
          },
        },
        [
          _c("template", { slot: "right-top" }, [
            _c("div", { staticClass: "counter" }, [
              _c("span", { staticClass: "counter__number" }, [
                _vm._v(" " + _vm._s(_vm.organizationsNumber) + " "),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "counter__label" }, [
                _vm._v(_vm._s(_vm.$t("eCircular.organizations"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "counter__number" }, [
                _vm._v(" " + _vm._s(_vm.currentHistory.sentTotal) + " "),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "counter__label" }, [
                _vm._v(_vm._s(_vm.$t("eCircular.recipients"))),
              ]),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "history-content" }, [
          _vm.totalResult
            ? _c("div", { staticClass: "total-count" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("total")) +
                      ": " +
                      _vm._s(_vm.filterTotalResult) +
                      " / " +
                      _vm._s(_vm.totalResult)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-results" },
            [
              _c("CommonTable", {
                attrs: {
                  tableContentLists: _vm.orderedItems,
                  renderHeaderList: _vm.eCircularHistoryTableTitle,
                  getDisplayListLength: _vm.getDisplayListLength,
                  interactionFunc: _vm.interactionFunc,
                  defaultOrderKey: "type",
                  defaultOrder: false,
                  needFilter: true,
                  minWidth1800px: false,
                  tableId: "e-circular-history-summary",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }